import React, { Component } from "react";
import { _lp } from "../logic/wording";
import { showSingupModal } from "../redux/actions/account_settings";
import { connect } from "react-redux";
import { store } from "../globals";
import baseLink from "../baseLink";


class _SingupModal extends Component {
  static closeModal() {
    store.dispatch(showSingupModal(false));
  }
  constructor(props) {
    super(props);
    this.state = {
      mail: "",
      password1: "",
      password2: "",
      cgu: false,
      singedUp: false,
      formErrors: [],
      background: '#fff',
      width: '0',
      text: ''
    };
  }

  componentDidMount() {
    if (this.refs.singupmodal) {
      if (this.props.show_singup_modal) {
        document.getElementById("singup-modal").appendChild(this.refs.singupmodal);
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }
    // const a = document.getElementById("singup-modal");
    // document.getElementById("singup-modal").addEventListener("click", e => {
    //   if (e.target !== a) _SingupModal.closeModal();
    // });
  }

  componentDidUpdate() {
    if (this.refs.singupmodal && !this.props.show_login_modal) {
      if (this.props.show_singup_modal) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  updateMail = val => {
    this.setState({
      mail: val.target.value
    });
  };

  updatePassword1 = val => {
    this.setState({
      password1: val.target.value
    });

    let strength = 0;
    let password = val.target.value;

    if (password.match(/[A-Z]/)) strength += 20;

    // Making sure it container lowercase letters
    if (password.match(/[a-z]/)) strength += 20;

    // Checking for number
    if (password.match(/[0-9]/)) strength += 20;

    // Checking for special chars
    if (password.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)) strength += 20;

    // Checking for length
    if (password.length > 7) strength += 20;

    let background = '';
    let text = '';

    if (strength < 21) {
      background = '#b80b0b';
      text = 'Très faible';
    } else if (strength < 41) {
      background = '#b8480b';
      text = 'Faible';
    } else if (strength < 61) {
      background = '#f08b08';
      text = 'Moyen';
    } else if (strength < 81) {
      background = '#c7c90f';
      text = 'Fort';
    } else {
      background = '#32c90f';
      text = 'Très fort';
    }

    this.setState({
      width: strength + '%',
      background,
      text
    })
  };

  updatePassword2 = val => {
    this.setState({
      password2: val.target.value
    });

    // Check if both passwords match
    let password1 = this.state.password1;
    let password2 = val.target.value;

    if (password1 !== password2) {
      raiseError("password2", 9, _lp("Les deux mots de passe sont différents"));
    } else {
      unraiseError("password2")
    }
  };

  updateCgu = val => {
    this.setState({
      cgu: val.target.checked
    })
  }

  signup = e => {
    e.preventDefault();
    unraiseError("form");

    const information = {
      email: this.state.mail,
      password: this.state.password1,
      password_repeat: this.state.password2
    };

    const init = {
      method: "POST",
      body: JSON.stringify(information)
    };

    const that = this;
    // managing errors
    let err0 = false;
    let err1 = false;
    let err2 = false;
    let err3 = false;

    if (this.state.mail !== "") {
      // Checking email
      let re = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g;
      if (!re.test(this.state.mail)) {
        raiseError("mail", 9, _lp("Veuillez saisir une adresse email correcte"));
        err2 = true;
      } else {
        unraiseError("mail");
      }
    } else {
      raiseError("mail", 9, _lp("Veuillez saisir votre adresse mail"));
      err0 = true;
    }

    if (this.state.password1 === "") {
      raiseError("password1", 9, _lp("Veuillez saisir votre mot de passe"));
      err1 = true;
    } else unraiseError("password1");

    if (this.state.password1 !== this.state.password2) {
      raiseError("password2", 9, _lp("Les deux mots de passe sont différents"));
      err2 = true;
    } else unraiseError("password2");

    if (!this.state.cgu) {
      raiseError("cgu", 9, _lp("Veuillez accepter les conditions d'utilisation"));
      err3 = true;
    } else unraiseError("cgu");

    if (!err0 && !err1 && !err2 && !err3) {
      fetch(`${baseLink}/data/contracts/signup`, init)
        .then(response => {
          response.json()
            .then((j_response) => {
              if (j_response.status === "success") {
                that.setState({
                  singedUp: true
                });

                _SingupModal.closeModal();

                let cnx = document.getElementById('connexion');
                cnx.innerText = j_response.data.userEmail;
                cnx.setAttribute('href', `${baseLink}/compte`);
                cnx.setAttribute('target', '_blank');
              } else {
                raiseError("form", 9, _lp(j_response.data.errors[0]));
              }
            })
            .catch(jsonError => {
              raiseError("global", 2, _lp("Erreur de connexion au serveur"));
            });
        })
        .catch(error => {
          raiseError("global", 2, _lp("Erreur de connexion au serveur"));
        });
    }
  }

  render() {
    return (
      <div ref="singupmodal">
        {this.props.show_singup_modal && (
          <div className="lpm user-modal signup-modal">
            <div className="lpm__container">
              <div className="lpm__header">
                <h3 className="lpm__title">Inscrivez vous à LegalPlace</h3>
                <div
                  className="lpm__close icn-x"
                  onClick={_SingupModal.closeModal}
                />
              </div>
              <div className="lpm__body">
                <div className="user-form">
                  <div className="user-form__body">
                    {this.props.error_form && <div className="alert error">
                      <span className="help-block">
                        {_lp(this.props.error_form.message)}
                    </span></div>}
                    <div
                      className = {`form-group ${
                        typeof this.props.error_mail === "undefined"
                          ? ""
                          : " error"
                      }`}
                    >
                      <label htmlFor="lf-email">Adresse email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="lf-email"
                        onChange={this.updateMail}
                      />
                      {typeof this.props.error_mail !== "undefined" && (
                        <span className="help-block">
                          {_lp(this.props.error_mail.message)}
                        </span>
                      )}
                    </div>
                    <div
                      className={`form-group ${
                        typeof this.props.error_password1 === "undefined"
                          ? ""
                          : " error"
                      }`}
                    >
                      <label htmlFor="lf-pass">Mot de passe</label>
                      <input
                        type="password"
                        className="form-control"
                        id="lf-pass"
                        onChange={this.updatePassword1}
                      />
                      {typeof this.props.error_password1 !== "undefined" && (
                        <span className="help-block">
                          {_lp(this.props.error_password1.message)}
                        </span>
                      )}
                    </div>
                    <div
                      className="password-strength form-group"
                      style={{display: 'block'}}
                    >
                      <span>Niveau de sécurité de votre mot de passe</span>
                      <div className="strength">
                        <div
                          className="bar"
                          style={{width: this.state.width, background: this.state.background}}
                          data-strength={this.state.width}
                        />
                      </div>
                      <div className="strength-txt">{this.state.text}</div>
                    </div>
                    <div
                      className={`form-group ${
                        typeof this.props.error_password2 === "undefined"
                          ? ""
                          : " error"
                      }`}
                    >
                      <label htmlFor="lf-pass2">Confirmez votre mot de passe</label>
                      <input
                        type="password"
                        className="form-control"
                        id="lf-pass2"
                        onChange={this.updatePassword2}
                      />
                      {typeof this.props.error_password2 !== "undefined" && (
                        <span className="help-block">
                          {_lp(this.props.error_password2.message)}
                        </span>
                      )}
                    </div>
                    <div className="user-form__actions">
                      <div
                        className={`form-group lp-chbx ${
                          typeof this.props.error_cgu === "undefined"
                            ? ""
                            : " error"
                        }`}
                      >
                        <input
                          type="checkbox"
                          id="cgv"
                          className="lpcbx"
                          onChange={this.updateCgu}
                        />
                        <label htmlFor="cgv">
                          J'ai lu et j'accepte les{" "}
                          <a href="/conditions-generales/" target="_blank">
                            conditions générales d'utilisation
                          </a>
                        </label>
                        {typeof this.props.error_cgu !== "undefined" && (
                        <span className="help-block">
                          {_lp(this.props.error_cgu.message)}
                        </span>
                      )}
                      </div>
                      <div onClick={this.signup}
                        className="btn btn-primary user-cta"
                      > Continuer
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.singedUp && (
          <div className="cf-success">
            <div className="success">Vous êtes maintenant connecté</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  show_singup_modal: state.account_settings.show_singup_modal,
  show_login_modal: state.account_settings.show_login_modal,
  error_mail: state.errors.components["mail"],
  error_password1: state.errors.components["password1"],
  error_password2: state.errors.components["password2"],
  error_cgu: state.errors.components["cgu"],
  error_form: state.errors.components["form"]
});

const mapDispatchToProps = dispatch => ({
  closeContact: () => {
    dispatch(showSingupModal(false));
  }
});

export const SingupModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(_SingupModal);



// WEBPACK FOOTER //
// ./src/components/singup_modal.js